module.exports = __webpack_public_path__ + "img/warning.ff046f64.svg";